"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultTheme = {
  backgroundColor: "#f9fafb",
  borderColor: "#dce4ef",
  primaryDark: "#162e51",
  // blueDark.
  primary: "#0978bc",
  // blue.
  primaryLight: "#27AAE1",
  // blueLight.
  primaryDust: "#dce4ef",
  // blueDust.
  secondaryDark: "#dfb100",
  // yellowDark.
  secondary: "#f9c642",
  // yellow.
  secondaryLight: "#fff1d2",
  // yellowLight.
  grayDark: "#323A45",
  grayMedium: "#A7AAAC",
  grayLight: "#dddddd",
  grayDust: "#eeeeee",
  headingColor: "#003366",
  textColor: "#3B3B3B",
  linkColor: "#0A77BD",
  linkHoverColor: "#003366",
  navBarBackgroundColor: "#0978bc",
  navBarBackgroundImage: "",
  navBarLink: "#FFFFFF",
  navBarLinkActive: "#FFFFFF",
  navBarLinkHoverBack: "#002245",
  navBarLinkActiveBack: "#305e92",
  navBarLinkActiveHoverBack: "#f2d13c",
  navBarLinkActiveHover: "#FFFFFF",
  heroBackgroundColor: "#0A77BD",
  heroTextColor: "#FFFFFF",
  heroHeadingColor: "#FFFFFF",
  footerBackgroundColor: "#162e51",
  footerText: "#FFFFFF",
  footerLink: "#FFFFFF",
  footerLinkHover: "#afc0cc",
  info: "#16A2B7",
  warning: "#FEC108",
  danger: "#DB3545",
  success: "#28A645",
  // Format
  csvIcon: "#dfb100",
  rdfIcon: "#0b4498",
  jsonIcon: "#ef7100",
  pdfIcon: "#e0051e",
  xmlIcon: "#5e962c",
  zipIcon: "1700b2",
  dataIcon: "#666666"
};
var _default = defaultTheme;
exports["default"] = _default;